import { useMemo } from "react";
import { useLang } from "@/i18n/LanguageContext";
import {
  parseResContent,
  aggregateBiomarkers,
  pickKeyFindings,
} from "@/lib/resParser";
import { getSupplementRecommendations } from "@/lib/supplementMatcher";
import ExecutiveSummary from "@/components/results/ExecutiveSummary";
import ResultsDetailTabs from "@/components/results/ResultsDetailTabs";
import EmailCapture from "@/components/EmailCapture";
import { ArrowUp, RotateCcw, Download } from "lucide-react";

export default function ResultsView({ result, onReset, onUnlock, onDownload }) {
  const { t } = useLang();

  const parsed = useMemo(() => parseResContent(result.resContent || ""), [result]);
  const aggregate = useMemo(() => aggregateBiomarkers(parsed.biomarkers), [parsed]);
  const findings = useMemo(
    () => pickKeyFindings(parsed, result.algorithmResult, 3),
    [parsed, result]
  );
  const recommendations = useMemo(
    () => getSupplementRecommendations(result.algorithmResult || {}),
    [result]
  );

  const handleDownload = onDownload || (async () => {});

  return (
    <div className="relative" data-testid="results-view">
      <ExecutiveSummary
        result={result}
        parsed={parsed}
        aggregate={aggregate}
        findings={findings}
      />
      <ResultsDetailTabs
        biomarkers={parsed.biomarkers}
        algorithmResult={result.algorithmResult || {}}
        recommendations={recommendations}
        onUnlockMore={onUnlock}
      />
      <EmailCapture />

      <div className="container-x flex flex-wrap items-center justify-between gap-4 pb-16">
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="btn-ghost"
          data-testid="results-back-top"
        >
          <ArrowUp className="h-4 w-4" />
          {t.results.backToTop}
        </button>
        <div className="flex flex-wrap items-center gap-3">
          <button
            onClick={handleDownload}
            className="btn-ghost"
            data-testid="results-download-pdf-bottom"
          >
            <Download className="h-4 w-4" />
            {t.results.download}
          </button>
          <button
            onClick={onReset}
            className="btn-primary"
            data-testid="results-new-analysis"
          >
            <RotateCcw className="h-4 w-4" />
            {t.results.newAnalysis}
          </button>
        </div>
      </div>
    </div>
  );
}
